module.exports = "/images/mastercard-icon.png";